import {
  get, post, put, del,
} from "services/api"
import { currentAccountId } from "services/authentication"
import { BadgeTemplate } from "sharedTypes/badge"
import { PaginationMeta } from "sharedTypes"
import { ExportFormat, SheetLayout } from "components/BadgeBuilder/utils/sheetPresets"

const baseUrl = (eventId: string) => `${
  import.meta.env.VITE_API_BASE
}/api/v3/accounts/${currentAccountId()}/events/${eventId}/badges`

export const getBadges = (eventId: string) => get<{ data: BadgeTemplate[]; meta: PaginationMeta }>(
  `${baseUrl(eventId)}.json`,
)

export const getBadge = (eventId: string, badgeId: string) => get<BadgeTemplate>(`${baseUrl(eventId)}/${badgeId}.json`)

export const postBadge = (eventId: string, badge: Partial<BadgeTemplate>) => post<BadgeTemplate>(`${baseUrl(eventId)}.json`, { badge })

export const putBadge = (
  eventId: string,
  badgeId: string,
  badge: Partial<BadgeTemplate>,
) => put<BadgeTemplate>(`${baseUrl(eventId)}/${badgeId}.json`, { badge })

export const deleteBadge = (eventId: string, badgeId: string) => del<void>(`${baseUrl(eventId)}/${badgeId}.json`)

export const postDuplicateBadge = (eventId: string, badgeId: string) => post<BadgeTemplate>(`${baseUrl(eventId)}/${badgeId}/duplicate.json`)

export const badgeImageUploadUrl = (eventId: string, badgeId: string) => `${
  import.meta.env.VITE_API_BASE
}/api/v3/accounts/${currentAccountId()}/events/${eventId}/badges/${badgeId}/uploads.json`

export const getBadgeExportUrl = (
  eventId: string,
  badgeId: string,
  ids?: string[],
  segmentId?: string,
  groupId?: string,
  dpi?: number,
  exportFormat?: ExportFormat,
  startPosition?: number,
  sheet?: SheetLayout,
) => {
  const url = `${baseUrl(eventId)}/${badgeId}.pdf`

  const params = new URLSearchParams()

  if (ids && ids.length > 0) {
    ids.forEach((id) => params.append("ids[]", id))
  }
  if (segmentId) {
    params.set("segment_id", segmentId)
  }
  if (groupId) {
    params.set("group_id", groupId)
  }
  if (dpi) {
    params.set("dpi", dpi.toString())
  }
  if (exportFormat && exportFormat !== ExportFormat.SINGLE) {
    params.set("export_format", exportFormat)
  }
  if (startPosition && startPosition > 1) {
    params.set("start_position", startPosition.toString())
  }
  if (sheet) {
    params.set("sheet[page_width_mm]", sheet.pageWidthMm.toString())
    params.set("sheet[page_height_mm]", sheet.pageHeightMm.toString())
    params.set("sheet[label_width_mm]", sheet.labelWidthMm.toString())
    params.set("sheet[label_height_mm]", sheet.labelHeightMm.toString())
    params.set("sheet[margin_top_bottom_mm]", sheet.marginTopBottomMm.toString())
    params.set("sheet[margin_left_right_mm]", sheet.marginLeftRightMm.toString())
    params.set("sheet[column_gap_mm]", sheet.columnGapMm.toString())
    params.set("sheet[row_gap_mm]", sheet.rowGapMm.toString())
  }

  const queryString = params.toString()

  return queryString ? `${url}?${queryString}` : url
}
